import React from 'react';
import Icon from '@/components/ui/AppIcon';

const StatsSection: React.FC = () => {
  const stats = [
    {
      icon: 'BuildingOfficeIcon',
      value: '47',
      label: 'Active Partners',
      description: 'Organizations worldwide',
    },
    {
      icon: 'GlobeAltIcon',
      value: '34',
      label: 'Countries',
      description: 'Global reach',
    },
    {
      icon: 'UserGroupIcon',
      value: '850K+',
      label: 'People Reached',
      description: 'Through partnerships',
    },
    {
      icon: 'HeartIcon',
      value: '89',
      label: 'Joint Initiatives',
      description: 'Collaborative projects',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300"
        >
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
            <Icon name={stat.icon as any} size={32} className="text-primary" />
          </div>
          <div className="text-4xl font-headline font-bold text-foreground mb-2">
            {stat.value}
          </div>
          <div className="text-lg font-semibold text-foreground mb-1">{stat.label}</div>
          <div className="text-sm text-muted-foreground">{stat.description}</div>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;